import { DateutilService } from './service/dateutil/dateutil.service';
import { Component } from '@angular/core';
// import Amplify from 'aws-amplify';
// import aws_exports from '../../awsmobilejs/#current-backend-info/aws-exports';
/*
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
*/
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../app/guard/auth.service';
import { Router } from '@angular/router';
// Amplify.configure(aws_exports);

@Component({
  selector: 'app-root',
  // template: `
  // <ul>
  //   <li *ngFor="let trip of trips | async">
  //     {{ trip | json }}
  //   </li>
  // </ul>
  // `,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
// export class AppComponent {
//   title = 'app';
//   trips: object;

//     constructor(private adb: AngularFireDatabase) {}

//     ngOnInit() {
//       this.adb.list<any>('0').valueChanges().subscribe(res => {
//       this.trips = res;
//       console.log(this.trips)
//     });
//   }
// }

export class AppComponent {
  title = 'app';
  // trips: Observable<any[]>;
  // // constructor(db: AngularFireDatabase) {
  // //   this.trips = db.list('CabTrack/Trips/Trip').valueChanges()
  // //   console.log(this.trips);
  // // }
  // constructor(db: AngularFirestore) {

  //   this.trips = db.collection('Trips').valueChanges()
  //   this.trips.subscribe(data =>
  //     console.log(data)
  //   )
  // }

  constructor(private bnIdle: BnNgIdleService,public auth: AuthService,private myRoute: Router,dateutil:DateutilService) { // initiate it in your component constructor
    this.bnIdle.startWatching(600).subscribe((res) => {
      if(res) {
          console.log("session expired");
          this.auth.logout();
         // this.myRoute.navigate(["Login"]);
      }
    })
    
  }

}
